import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { AvailStockDto } from '.';
export class AvailableStockQtyResponseModel extends GlobalResponseObject {
    data?: AvailStockDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: AvailStockDto){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

